import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { RegistrationService } from 'src/app/shared/services/registration.service';

@Component({
  selector: 'app-anemia-modal',
  templateUrl: './anemia-modal.component.html',
  styleUrls: ['./anemia-modal.component.css']
})
export class AnemiaModalComponent implements OnInit {
  @Input() benID: any
  @Input() AlraedyDataAdded: any

  anemiaForm: FormGroup;


  constructor(
    public activeModal: NgbActiveModal,
    private regService: RegistrationService,
    private toastr: ToastrService,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.formInIt();
  }

  formInIt() {
    this.anemiaForm = this.fb.group({
      is_pregnant_woman: [],
      is_child: [],
      is_adolescent: [],
      is_high_risk: [],
      fatigue: [],
      pale_skin: [],
      dizziness: [],
      shortness_of_breath: [],
      headache: [],
      hemoglobin_test_done: [],
      test_method: [],
      hemoglobin_value: [],
      anemia_category: [],
      ifa_supplement_given: [],
      diet_counseling_done: [],
      referred: [],
      referral_facility: [],
    });
  }
  onHbChange(value: any) {
    const category = this.anemiaValidation(value);

    this.anemiaForm.patchValue({
      anemia_category: category
    });
  }
  anemiaValidation(event: any) {
    if (event) {
      const hb = parseFloat(event);
      if (isNaN(hb)) return '';
      if (hb >= 12) return 'Normal';
      if (hb >= 10 && hb <= 11.9) return 'Mild Anemia';
      if (hb >= 7 && hb <= 9.9) return 'Moderate Anemia';
      if (hb < 7) return 'Severe Anemia';
    }
  }

  onSave() {
    console.log('Anemia Data', this.anemiaForm.value);
    this.activeModal.close(this.anemiaForm.value);
  }
}
